import _omit from 'lodash/omit';
import {DTConditionNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {SETUP_AGENT_STORAGE_PREFIX} from '../../promptToCardAgentV2.consts';

export default function setCardInState(card: DTConditionNode) {
  const cardWithoutNode = _omit(card, 'inputs');
  sessionStorage.setItem(SETUP_AGENT_STORAGE_PREFIX, JSON.stringify(cardWithoutNode));
}
